import { jsx as _jsx } from "react/jsx-runtime";
import { lazy } from 'react';
import { CONSTANTS } from '../commons/const';
var DisplayList = lazy(function () { return import('@/modules/pid-cms/pages/displays'); });
var Campaigns = lazy(function () { return import('@/modules/pid-cms/pages/campaigns'); });
var ImageLibrary = lazy(function () { return import('@/modules/pid-cms/pages/imageLibrary'); });
var ImageLibraryDetail = lazy(function () { return import('@/modules/pid-cms/pages/imageLibrary/detail'); });
var BroadCast = lazy(function () { return import('@/modules/pid-cms/pages/broadcast'); });
var Geofence = lazy(function () { return import('@/modules/pid-cms/pages/geofence'); });
var Route = lazy(function () { return import('@/modules/pid-cms/pages/route'); });
var Stop = lazy(function () { return import('@/modules/pid-cms/pages/stop'); });
import { ThemeProvider, createTheme } from '@mui/material';
import { themeSettings } from '@/hooks/theme';
import { DEFAULT_FONT_FAMILY } from '@/utils/helpers';
var theme = createTheme(themeSettings('light', DEFAULT_FONT_FAMILY));
export var PidCmsRoutes = [
    {
        path: CONSTANTS.ROUTES.DISPLAY,
        element: (_jsx(ThemeProvider, { theme: theme, children: _jsx(DisplayList, {}) })),
    },
    {
        path: CONSTANTS.ROUTES.CAMPAIGNS,
        element: (_jsx(ThemeProvider, { theme: theme, children: _jsx(Campaigns, {}) })),
    },
    {
        path: CONSTANTS.ROUTES.IMAGE_LIBRARY,
        element: (_jsx(ThemeProvider, { theme: theme, children: _jsx(ImageLibrary, {}) })),
        // children: [
        //   {
        //     path: CONSTANTS.ROUTES.IMAGE_LIBRARY + '/:path/*',
        //     element: <ImageLibraryDetail />,
        //   },
        // ],
    },
    {
        path: CONSTANTS.ROUTES.IMAGE_LIBRARY + '/:path/*',
        element: (_jsx(ThemeProvider, { theme: theme, children: _jsx(ImageLibraryDetail, {}) })),
    },
    {
        path: CONSTANTS.ROUTES.BROADCAST_TEXT_MESSAGE,
        element: (_jsx(ThemeProvider, { theme: theme, children: _jsx(BroadCast, {}) })),
    },
    {
        path: CONSTANTS.ROUTES.GEOFENCE,
        element: (_jsx(ThemeProvider, { theme: theme, children: _jsx(Geofence, {}) })),
    },
    {
        path: CONSTANTS.ROUTES.ROUTE,
        element: (_jsx(ThemeProvider, { theme: theme, children: _jsx(Route, {}) })),
    },
    {
        path: CONSTANTS.ROUTES.STOP,
        element: (_jsx(ThemeProvider, { theme: theme, children: _jsx(Stop, {}) })),
    },
];
